import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Build;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';
import { jsx } from '@instructure/emotion';
import { List } from '@instructure/ui-list';
import { Text } from '@instructure/ui-text';
import { Card, CardContent, CardWrapper, Page, QuizzesSpinner as Spinner, generateDisplayPositions, BanksTray, BuildingSidebar, DeleteStimulusModal, ItemFeedbackModal, MoveImmutableModal, AddContentModal, QTIImportModal, ReturnButton } from '@instructure/quiz-core';
import t from '@instructure/quiz-i18n/es/format-message';
import { Alert } from '@instructure/ui-alerts';
import { BaseHeader as QuizHeader } from './components/Header';
import { BuildContent } from './components/BuildContent';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { PARENT_TYPE_QUIZ, withStyleOverrides } from '@instructure/quiz-common';
import { loadMathjs } from '@instructure/quiz-interactions';
export var Build = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Build = /*#__PURE__*/function (_Component) {
  function Build() {
    _classCallCheck(this, Build);
    return _callSuper(this, Build, arguments);
  }
  _inherits(Build, _Component);
  return _createClass(Build, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadQuiz();
      this.checkForInvalidQuizEntries();
      this.props.clearActiveQuizSession();
      loadMathjs(); // Used by Formula Edit component
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.activeQuizId !== prevProps.activeQuizId) {
        this.loadQuiz();
      }
      if (!this.props.quizEntries.equals(prevProps.quizEntries)) {
        this.checkForInvalidQuizEntries();
      }
    }

    // ===========
    //   HELPERS
    // ===========
  }, {
    key: "loadQuiz",
    value: function loadQuiz() {
      var _this$props = this.props,
        activeQuizId = _this$props.activeQuizId,
        clearErrorsShowing = _this$props.clearErrorsShowing,
        contextId = _this$props.contextId,
        quizBuildingSession = _this$props.quizBuildingSession;
      clearErrorsShowing();
      quizBuildingSession({
        activeQuizId: activeQuizId,
        contextId: contextId,
        createNew: true
      });
    }
  }, {
    key: "getDisplayPositionsForInvalidQuizEntries",
    value: function getDisplayPositionsForInvalidQuizEntries() {
      var quizEntries = this.props.quizEntries;
      var invalidQuizEntries = quizEntries.filter(function (qe) {
        return !qe.isValid();
      });
      if (invalidQuizEntries.size > 0) {
        var positionMap = generateDisplayPositions(quizEntries, true);
        return invalidQuizEntries.map(function (qe) {
          return positionMap[qe.id];
        }).toJS();
      }
    }
  }, {
    key: "getInvalidMessage",
    value: function getInvalidMessage(invalidPositions) {
      return jsx("div", null, jsx(Text, {
        weight: "bold"
      }, t('Invalid Items.')), "\xA0", t('Students will not be able to take this assessment until they are resolved.'), jsx(List, null, invalidPositions.map(function (position) {
        return jsx(List.Item, {
          key: position
        }, t('question { position, number }', {
          position: position
        }));
      })));
    }
  }, {
    key: "checkForInvalidQuizEntries",
    value: function checkForInvalidQuizEntries() {
      var invalidPositions = this.getDisplayPositionsForInvalidQuizEntries();
      if (invalidPositions) {
        this.props.addError(this.getInvalidMessage(invalidPositions), false, 'invalid_quiz_alert');
      } else {
        this.props.removeAlert('invalid_quiz_alert');
      }
    }
  }, {
    key: "renderReturnButton",
    value: function renderReturnButton() {
      if (this.props.returnToUrl) {
        return jsx("div", {
          css: this.props.styles.footer
        }, jsx(ReturnButton, {
          returnToUrl: this.props.returnToUrl
        }));
      }
    }
  }, {
    key: "renderInformationBanner",
    value: function renderInformationBanner() {
      if (this.props.informationBanner) {
        return jsx("div", {
          css: this.props.styles.alert
        }, jsx(Alert, {
          variant: "info"
        }, this.props.informationBanner));
      }
      return null;
    }

    // =============
    //   RENDERING
    // =============
  }, {
    key: "render",
    value: function render() {
      var quiz = this.props.quiz;
      if (!this.props.quiz.isLoaded()) {
        return jsx(Card, {
          wrapped: true
        }, jsx(Spinner, null));
      }
      return jsx("div", {
        css: this.props.styles.builder
      }, jsx(Page, {
        contentRole: this.props.contentRole,
        sidebarComponent: BuildingSidebar,
        sidebarOpen: this.props.sidebarOpen,
        sidebarRole: this.props.sidebarRole,
        toggleSidebar: this.props.toggleSidebar
      }, jsx(CardWrapper, null, jsx(QTIImportModal, {
        qtiImport: quiz.getLatestImport(),
        parentId: quiz.id,
        parentType: PARENT_TYPE_QUIZ,
        waitForAssignmentSettingsImported: this.props.waitForAssignmentSettingsImported
      }), jsx(ItemFeedbackModal, null), jsx(DeleteStimulusModal, null), jsx(MoveImmutableModal, null), jsx(AddContentModal, null), jsx("div", {
        css: this.props.styles.header
      }, jsx(QuizHeader, Object.assign({}, this.props, {
        scrollKey: "header"
      })), this.renderInformationBanner()), jsx(CardContent, null, jsx(BuildContent, {
        onQuizUpdated: this.props.onQuizUpdated
      }), this.renderReturnButton()), jsx(BanksTray, {
        currentUser: this.props.currentUser,
        getCourseInfo: this.props.getCourseInfo,
        getCourseAssignments: this.props.getCourseAssignments,
        getUserInfo: this.props.getUserInfo,
        getSubaccountInfo: this.props.getSubaccountInfo,
        getShareableCourses: this.props.getShareableCourses,
        getShareableUsers: this.props.getShareableUsers,
        getShareableSubaccounts: this.props.getShareableSubaccounts,
        minChars: this.props.minChars,
        onShare: this.props.onShare,
        itemBanksScope: this.props.itemBanksScope
      }))));
    }
  }]);
}(Component), _defineProperty(_Build, "displayName", 'Build'), _defineProperty(_Build, "componentId", "Quizzes".concat(_Build.displayName)), _defineProperty(_Build, "propTypes", {
  activeQuizId: PropTypes.string.isRequired,
  // passed in by consumer
  addError: PropTypes.func.isRequired,
  clearActiveQuizSession: PropTypes.func.isRequired,
  clearErrorsShowing: PropTypes.func.isRequired,
  contentRole: PropTypes.string,
  contextId: PropTypes.string,
  // passed in by consumer
  getCourseInfo: PropTypes.func,
  // passed in by consumer
  getCourseAssignments: PropTypes.func,
  // passed in by consumer
  currentUser: PropTypes.shape({
    bank_admin: PropTypes.bool,
    can_share_banks_with_subaccounts: PropTypes.bool,
    email: PropTypes.string,
    enrollment_names: PropTypes.arrayOf(PropTypes.string),
    full_name: PropTypes.string,
    uuid: PropTypes.string,
    account_name: PropTypes.string
  }),
  // passed in by consumer
  getShareableCourses: PropTypes.func,
  // passed in by consumer
  getShareableUsers: PropTypes.func,
  // passed in by consumer
  getShareableSubaccounts: PropTypes.func,
  // passed in by consumer
  getSubaccountInfo: PropTypes.func,
  // passed in by consumer
  getUserInfo: PropTypes.func,
  // passed in by consumer
  isEditing: PropTypes.bool.isRequired,
  minChars: PropTypes.number,
  // passed in by consumer
  onShare: PropTypes.func,
  // passed in by consumer
  onQuizUpdated: PropTypes.func,
  // passed in by consumer, optional
  onPreviewClicked: PropTypes.func,
  // passed in by consumer, optional
  quiz: ImmutablePropTypes.record.isRequired,
  quizBuildingSession: PropTypes.func.isRequired,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  removeAlert: PropTypes.func.isRequired,
  returnToUrl: PropTypes.string,
  // passed in by consumer
  sidebarOpen: PropTypes.bool,
  sidebarRole: PropTypes.string,
  toggleSidebar: PropTypes.func,
  useBankTags: PropTypes.bool,
  waitForAssignmentSettingsImported: PropTypes.func,
  informationBanner: PropTypes.string,
  itemBanksScope: PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    title: PropTypes.string,
    launch_context_uuid: PropTypes.string,
    root_account_name: PropTypes.string
  }),
  styles: PropTypes.object
}), _defineProperty(_Build, "defaultProps", {
  contentRole: void 0,
  contextId: null,
  currentUser: null,
  errorsShowing: Map(),
  getShareableCourses: null,
  getShareableUsers: null,
  minChars: void 0,
  getCourseInfo: null,
  getCourseAssignments: null,
  getUserInfo: null,
  getShareableSubaccounts: null,
  getSubaccountInfo: null,
  onShare: function onShare() {},
  onQuizUpdated: function onQuizUpdated() {},
  returnToUrl: null,
  sidebarOpen: void 0,
  sidebarRole: void 0,
  toggleSidebar: void 0,
  useBankTags: false,
  waitForAssignmentSettingsImported: null,
  onPreviewClicked: null,
  informationBanner: null,
  itemBanksScope: {}
}), _Build)) || _class);
export default Build;